module.exports = __webpack_public_path__ + "img/nail1.c5d47df0.jpg";